var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"transform":"rotate(45 10 10)","d":"M11.725-2.078V8.275h10.353v3.45H11.725v10.353h-3.45V11.725H-2.078v-3.45H8.275V-2.078h3.45z"}})}
var staticRenderFns = []

export { render, staticRenderFns }